import { useSelector } from 'react-redux';
import { NavLink, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const { userInfo } = useSelector((state) => state.auth);

  if (userInfo === null || (userInfo !== null && userInfo._id === null)) {
    return (
      <div className='bg-black'>
        {/* 401 Unauthorized Page in tailwind*/}
        <div className='flex flex-col flex-1 items-center justify-center h-screen'>
          <img
            src='/img/generic.png'
            alt='logo'
            className='w-[700px] mb-10'
          />
          <div className='flex flex-col items-center justify-center'>
            <NavLink
              to='/login'
              className='px-9 py-4 no-underline mt-8 font-semibold bg-white text-gray-800 rounded hover:bg-slate-100'
            >
              LOGIN
            </NavLink>
          </div>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
